import CartItemView from 'package-cart-item.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPerformance, IZone } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { removeItemFromCart, removeSelectedZone } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { flatMap } from 'lodash';
import { getCartItemDetails } from '../../helpers/cart-helpers';
import { IPerformanceErrorMessage } from '../../../package-listing/classes/package-listing';


interface ICartItemExternalProps {
    itemId: number;
    selectedZoneId: number;
}

interface StateToProps {
    text: IPackageListingAppText;
    itemProcessErrorMessage: string;
    selectedZone: IZone;
    isUnseated: boolean;

    itemIdToRemove: number;
    itemTitle: string;
    itemFacility: string;
    itemDateString: string;
    itemTimeString: string;

    showRemoveButton: boolean;
    showChangeZoneButton: boolean;
}

interface DispatchToProps {
    removeItem: (itemId: number) => void;
    removeZone: (itemId: number) => void;
}

export type CartItemProps = ICartItemExternalProps & StateToProps & DispatchToProps;

export type CombineCartViewProps = CartItemProps;

export class FiltersBase extends React.Component<CartItemProps, any> {
    constructor(props: CartItemProps) {
        super(props);
    }

    render() {
        return <CartItemView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: ICartItemExternalProps): StateToProps {
    var perfMessage: Array<IPerformanceErrorMessage> = [];
    if (state.packageListing.errorMessages != undefined)
        perfMessage = state.packageListing.errorMessages.filter(err => err.performanceId === ownProps.itemId);
    var performancePricing = state.packageListing.performancePricingList
        .get(ownProps.itemId);

    var itemDetails = getCartItemDetails(state, ownProps.itemId);

    if (!performancePricing) {
        performancePricing = state.packageListing.performancePricingList.get(itemDetails.itemIdToRemove);
    }


    return {
        text: state.packageListingText,
        itemProcessErrorMessage: perfMessage.length > 0 ? perfMessage[0].errorMessage : "",
        selectedZone: performancePricing ? performancePricing.zones
            .filter(z => z.zone.id == ownProps.selectedZoneId)[0]
            : null,
        isUnseated: state.packageListingSettings.useUnseatedReservation,
        itemIdToRemove: itemDetails.itemIdToRemove,
        itemDateString: itemDetails.itemDate,
        itemTimeString: itemDetails.itemTime,
        itemFacility: itemDetails.facility.facilityDescription,
        itemTitle: itemDetails.itemTitle,
        showRemoveButton: state.packageListing.packages.length !== 1,
        showChangeZoneButton: performancePricing ? performancePricing.zones.length > 1
            : false
    }
}

function mapDispatchToProps(dispatch, ownProps: CartItemProps): DispatchToProps {
    return {
        removeItem: (itemId: number) => {
            dispatch(removeItemFromCart(itemId));

        },
        removeZone: (itemId: number) => {
            dispatch(removeSelectedZone(itemId));

        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(FiltersBase);